import fetchJSON from '@api/api_helper';

const getUrl = (attachmentKey) => `/api/v4/attachments/${attachmentKey}/versions`;
const getrollbackUrl = (versionKey) => `/api/v4/versions/${versionKey}/rollback`;

export default (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.attachmentKey), options, updateFetchControllers)
);

export const postVersions = (options, updateFetchControllers) => {
  const url = getUrl(options.attachmentKey);
  const data = {
    status: options.updatedStatus,
    note: options.checkinCheckoutNote
  };
  const appendedOptions = {
    body: { data: { attributes: data } },
    method: 'POST'
  };

  if (options.params) {
    appendedOptions.params = options.params;
  }

  return fetchJSON(url, appendedOptions, updateFetchControllers);
};

export const rollbackVersions = (options, updateFetchControllers) => {
  const appendedOptions = { method: 'POST' };

  return fetchJSON(getrollbackUrl(options.versionKey), appendedOptions, updateFetchControllers);
};
